import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LinearProgress } from '@mui/material';
import Main from './pages/Main';
import CreateUser from './pages/CreateUser';
import Error from './pages/Error';
import Registration from './pages/Registration';
import Success from './pages/Success';
import Devices from './pages/Devices';
import Logout from './pages/Logout';
import ActivateNewLocation from './pages/ActivateNewLocation';
import ActivateDevice from './pages/ActivateDevice';
import ActivateEmail from './pages/ActivateEmail';
import Privacy from './pages/Privacy';
import Agreement from './pages/Agreement';
import Link from './pages/Link';
import Personified from './pages/Personalized';
import NonPersonalized from './pages/NonPersonalized';
import ConfirmIpAddress from './pages/ConfirmIpAddress';
import WebTokenActivateContract from './pages/WebTokenActivateContract';
import { PasswordSetup } from './pages/PasswordSetup';
import { ChangePassword } from './pages/ChangePassword';
import { ForgotPassword } from './pages/ForgotPassword';
import { RecoveryEmailSent } from './pages/RecoveryEmailSent';
import { PasswordReset } from './pages/PasswordReset';
import { TryAgain } from './pages/TryAgain';
import Portfolio from './pages/Portfolio';

const theme = createTheme({
  palette: {
    primary: {
      main: '#009393'
    },
    secondary: {
      main: '#FF3800'
    },
    error: {
      main: '#FF3800'
    }
  }
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={<LinearProgress color="primary" />}>
        <Router basename={'/auth'}>
          <Switch>
            <Route exact path="/" component={Main} />
            <Route exact path="/createUserMarketing" component={CreateUser} />
            <Route exact path="/token/:webToken" component={PasswordSetup} />
            <Route exact path="/reset/:webToken" component={PasswordReset} />
            <Route exact path="/link/:webToken" component={Link} />
            <Route exact path="/logout" component={Logout} />
            <Route exact path="/registration" component={Registration} />
            <Route exact path="/success" component={Success} />
            <Route exact path="/devices" component={Devices} />
            <Route exact path="/changePassword" component={ChangePassword} />
            <Route exact path="/forgotPassword" component={ForgotPassword} />
            <Route
              exact
              path="/recoveryEmailSent"
              component={RecoveryEmailSent}
            />
            <Route exact path="/tryAgain" component={TryAgain} />
            <Route
              exact
              path="/ip/:token/confirm"
              component={ConfirmIpAddress}
            />
            <Route
              exact
              path="/p/:webToken/:internalUrl"
              component={Personified}
            />
            <Route
              exact
              path="/crm/contract/:contractID/activation/:webToken"
              component={WebTokenActivateContract}
            />
            <Route exact path="/p/:webToken/*" component={Personified} />
            <Route exact path="/s/:internalUrl" component={NonPersonalized} />
            <Route exact path="/s/*" component={NonPersonalized} />
            <Route
              exact
              path="/devices/:deviceId/newlocation/:token"
              component={ActivateNewLocation}
            />
            <Route
              exact
              path="/devices/:deviceId/activate/:token"
              component={ActivateDevice}
            />
            <Route
              exact
              path="/registration/:uid/confirmation/:token"
              component={ActivateEmail}
            />
            <Route exact path="/:lng/privacy" component={Privacy} />
            <Route exact path="/:lng/agreement" component={Agreement} />
            <Route exact path="/:lng/portfolio" component={Portfolio} />
            <Route component={Error} />
          </Switch>
        </Router>
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
